//import this component froom dashboard folder
import { useTranslation } from "react-i18next";
import MuscleDiagramCard from "../../../../dashboard/calendar/components/MuscleDiagramCard";

const WorkloadStats = () => {
  const { t } = useTranslation("athlete-portal");
  return (
    <article id="workload">
      <header>
        <h4>{t("bodyComposition.workload.title")}</h4>
        <p className="p4">{t("bodyComposition.averageForWeek")}</p>
      </header>

      <MuscleDiagramCard isComposition={true} />
    </article>
  );
};

export default WorkloadStats;
